"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 14 16'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Desktop",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "GUI",
    transform: "translate(-211.000000, -9039.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-2",
    transform: "translate(180.000000, 8614.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-20",
    transform: "translate(15.000000, 424.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "icon-document",
    transform: "translate(16.000000, 1.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.5,16 C0.672666667,16 0,15.3273333 0,14.5 L0,3.75 C0,3.474 0.224,3.25 0.5,3.25 C0.776,3.25 1,3.474 1,3.75 L1,14.5 C1,14.776 1.224,15 1.5,15 L10.5,15 C10.776,15 11,15.224 11,15.5 C11,15.776 10.7753333,16 10.5,16 L1.5,16 Z",
    id: "Path"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.65933333,13.8333333 C2.72266667,13.8073333 1.978,13.0273333 2,12.0946667 L2,1.728 C1.97866667,0.803333333 2.72,0.026 3.65266667,0 L9.6,0 C10.05,0.002 10.4826667,0.190666667 10.7893333,0.516666667 L13.02,2.864 C13.3313333,3.19466667 13.5013333,3.62466667 13.4993333,4.07666667 L13.4993333,12.1026667 C13.5186667,13.0286667 12.7773333,13.8066667 11.8466667,13.8326667 L3.666,13.8326667 C3.664,13.8333333 3.662,13.8333333 3.65933333,13.8333333 Z M3.67,1 C3.29133333,1.012 2.99066667,1.33266667 3,1.716 L3,12.106 C2.99133333,12.4993333 3.296,12.8226667 3.68066667,12.834 L11.8333333,12.834 C12.2066667,12.8233333 12.5093333,12.5026667 12.5,12.1186667 L12.5,4.07533333 C12.5006667,3.87933333 12.4273333,3.69333333 12.294,3.55133333 L10.0633333,1.204 C9.942,1.07533333 9.77266667,1.00133333 9.598,1 L3.67,1 Z",
    id: "Shape"
  })))))));
});